import React from 'react';

import PropTypes from 'prop-types';

import { BulkUpdateTypeDataPropType } from '../../prop-types/bulk-update-type-data';
import { BulkActionDataTypes } from '../../services/bulk-update-type-data';
import style from './bulk-apply-message.module.less';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { BannerLayout, BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { Text, TextType } from 'ui-components/components/text';
import { MessageDescriptorPropType } from '../../prop-types/intl';

export const BulkApplyMessage = ({
  bulkUpdateTypeData = BulkActionDataTypes.getBulkUpdateTypeData('salesOrder'),
  count = 0,
  customMessage,
}) => (
  <>
    {customMessage ? (
      <BannerMessageV2
        content={
          <Text
            textType={TextType.Caption}
            value={
              <>
                {customMessage.header}
                <br />
                <span>{customMessage.content}</span>
              </>
            }
          />
        }
        layout={BannerLayout.Inline}
        status={BannerStatus.Info}
      />
    ) : (
      <div className={style['bulk-apply-message']} data-testid='bulk-apply-message-wrapper'>
        {bulkUpdateTypeData.bulkApplyMessage(count)}
      </div>
    )}
  </>
);

BulkApplyMessage.propTypes = {
  bulkUpdateTypeData: BulkUpdateTypeDataPropType,
  count: PropTypes.number,
  customMessage: PropTypes.shape({
    header: PropTypes.oneOfType([PropTypes.node, MessageDescriptorPropType]),
    content: PropTypes.oneOfType([PropTypes.node, MessageDescriptorPropType]),
  }),
};
